import React from 'react'
import {NavLink} from 'react-router-dom'

const NavBar = () => {
    return ( <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-dark bg-dark border-bottom box-shadow mb-3 ">
                <div className="container">
                    <NavLink className="navbar-brand " to="/">
                    <img src={require("../assets/img/LogoDiag2.png")} alt="logo" />&nbsp;Cogitations on Physics, Math, and Computers&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </NavLink>
                    <button className="navbar-toggler " type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse">
                        <ul className="navbar-nav flex-grow-1">               
                <li className="nav-item dropdown">
                    <a className="nav-link text-light dropdown-toggle" href="/" id="navbardrop" data-bs-toggle="dropdown" aria-expanded="false">
                        Home
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="navbardrop">
                        <li><a className="dropdown-item" href="https://react.larrymusa.com/">React Version</a></li>
                        <li><a className="dropdown-item" href="https://larrymusa.com/" target="_blank" rel="noopener noreferrer">.Net Core Version</a></li>
                        <li><a className="dropdown-item" href="https://angular.larrymusa.com/#/" target="_blank" rel="noopener noreferrer">Angular Version</a></li>
                        <li><a className="dropdown-item" href="https://go.larrymusa.com/" target="_blank" rel="noopener noreferrer">Golang Version</a></li>
                    </ul>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link text-light"  to="/Physics">Physics</NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link text-light"  to="/CargoCultScience">Cargo Cult Science</NavLink>
                </li>
            </ul>
        </div>
    </div>
</nav>  );
}
 
export default NavBar ;